// extracted by mini-css-extract-plugin
module.exports = {"hidden":"acc_hidden__RJ5EU","textEmphasis":"acc_textEmphasis__3sEOf","wrapper":"acc_wrapper__gFfuh"};